import { Component, OnInit } from "@angular/core";
import { AbstractWidgetComponent, ContextChange } from "@sdbn/appclient";
import { TranslationService } from "@sdbn/common";
import { TerminalContextConstants } from "src/tmc-common/model/terminal-context-constants";

@Component({
  selector: 'app-transport-further-info',
  templateUrl: './transport-further-info.component.html',
  styleUrls: ['./transport-further-info.component.scss']
})
export class TransportFurtherInfoComponent extends AbstractWidgetComponent implements OnInit {

  useGlobalConnect = false;
  usePhoneCall = false;
  useSms = false;

  constructor(public translationService: TranslationService) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    const selectedCommunicationOption = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication);
    console.log('-------------------------', selectedCommunicationOption);
    if (selectedCommunicationOption === 'phone-call') {
      this.usePhoneCall = true;
    } else if (selectedCommunicationOption === 'sms') {
      this.useSms = true;
    }  else if (selectedCommunicationOption === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE) {
      this.useGlobalConnect = true;
    }
  }

  ngOnInit(): void {
  }
}
